// Bài hướng dẫn trang Tra đồ — /tra-do (QĐ 0538).
//
// ⚠️ Ranh giới thông tin ở `../types.ts` áp NGUYÊN VẸN.

import type { GuideBook } from "../types";

export const WARDROBE_LOOKUP_GUIDES: GuideBook = {
  wardrobe_lookup: {
    purpose: "Tra đồ thật đang có trong kho, khớp concept và số đo của khách, để tư vấn và gửi ảnh cho khách trước buổi chụp.",
    where: [
      'Khung lọc ở đầu trang: "Cơ sở", "Ngày chụp", "Concept", "Giới tính", "Loại đồ", "Màu". Trên điện thoại các ô này nằm trong nút "Bộ lọc".',
      'Khung "Số đo khách" ngay dưới: chiều cao, cân nặng, vòng ngực, vòng eo, vòng mông, vòng bắp tay, rộng vai, "Size hay mặc" và "Ghi chú số đo". Ô nào không biết thì để trống. Trên điện thoại, khách đã có số đo thì khung gập thành một dòng tóm tắt; bấm "Sửa số đo" để mở lại.',
      'Công tắc "Xem cả đồ không vừa" và nút "Lưu số đo vào hồ sơ khách" (nút này chỉ có khi mở từ một đơn).',
      'Dòng "Cập nhật từ kho lúc …" cho biết lần cuối kho gửi danh sách đồ.',
      "Lưới thẻ đồ: ảnh, tên, size, mã dán trên đồ, cơ sở đang giữ, nhãn vừa, nhãn concept, trạng thái trong kho. Bấm vào ảnh hoặc ô vuông ở góc ảnh để chọn chiếc đó.",
      'Chọn ít nhất một chiếc thì hiện thanh dưới cùng với nút "Tải ảnh" và nút "Ghim vào đơn" (nút ghim chỉ có khi mở từ một đơn).',
      'Ở trang chi tiết đơn có khối "Đồ khách đã chọn" và nút "Tra đồ cho khách này" để mở trang này cho đúng đơn đó.',
    ],
    howItWorks: [
      "Danh sách đồ do kho gửi sang và tự cập nhật khi kho đổi trạng thái hay số đo của từng chiếc. Trang này chỉ xem, không sửa được thông tin đồ.",
      "Mở từ đơn thì cơ sở, ngày chụp, concept, giới tính và số đo đã lưu của khách tự điền sẵn. Đổi ô nào thì danh sách đổi theo ngay.",
      "Gõ số đo của khách xong, mỗi chiếc đồ tự hiện nhãn vừa kèm lý do ngắn. Chỉ biết size hay mặc thì so theo size chữ.",
      'Đồ không vừa được ẩn sẵn; bật "Xem cả đồ không vừa" để hiện lại. Đã chọn concept thì chỉ hiện đồ đúng concept và đồ gần giống.',
      "Đồ đúng concept đứng trước, rồi đến đồ vừa hơn, đồ đang sạch, đồ ít được ghim cho khách khác cùng ngày.",
      '"Ghim vào đơn" chỉ ghi lại lựa chọn của khách để ekip ngày chụp thấy. Ghim KHÔNG giữ chỗ: chiếc đồ vẫn có thể được ghim cho khách khác.',
      '"Lưu số đo vào hồ sơ khách" lưu số đo vào thông tin khách của đơn; lần sau khách đặt đơn khác, số đo tự điền sẵn.',
      '"Tải ảnh" mở ảnh lớn của các chiếc đã chọn ở thẻ mới để lưu và gửi cho khách.',
    ],
    statuses: [
      { label: "Vừa", meaning: "Số đo của khách nằm trong khoảng mặc vừa của chiếc đồ." },
      { label: "Vừa nhờ giãn", meaning: "Khách lớn hơn một chút nhưng vải giãn được tới số đó." },
      { label: "Gần vừa", meaning: "Lệch ít, xem lý do ghi dưới thẻ để biết lệch ở đâu." },
      { label: "Không vừa", meaning: "Lệch nhiều; mặc định ẩn." },
      { label: "Đúng concept", meaning: "Chiếc đồ thuộc concept khách đã chọn." },
      { label: "Gần giống", meaning: "Không thuộc concept đó nhưng cùng phong cách hoặc màu, hoặc thuộc concept na ná." },
      { label: "Đã ghim cho N đơn khác cùng ngày", meaning: "Khách khác chụp cùng ngày cũng đã chọn chiếc này. Vẫn ghim được, nhưng nên báo khách có thể phải đổi." },
      { label: "Số đo theo bảng size chung", meaning: "Kho chưa đo riêng mẫu này, khoảng vừa lấy theo bảng size chung nên chỉ mang tính tham khảo." },
      { label: "Sạch / Đang dùng / Chờ giặt / Đang giặt / Đang sửa", meaning: "Trạng thái hiện tại của chiếc đồ trong kho." },
      { label: "Đã ghim cho đơn này", meaning: "Chiếc đồ đã nằm trong lựa chọn của đơn đang mở." },
    ],
    blocks: [
      {
        for: ["sale", "cskh", "reception"],
        title: "Việc của Sale, CSKH và lễ tân",
        steps: [
          'Mở đơn của khách, bấm "Tra đồ cho khách này" ở khối "Đồ khách đã chọn".',
          'Hỏi khách số đo, gõ vào khung "Số đo khách". Khách chỉ biết size thì gõ vào "Size hay mặc", ví dụ L–XL.',
          'Bấm "Lưu số đo vào hồ sơ khách" để lần sau không phải hỏi lại.',
          'Chọn các chiếc hợp với khách, bấm "Tải ảnh" để gửi khách xem.',
          'Khách chốt chiếc nào thì chọn chiếc đó rồi bấm "Ghim vào đơn".',
        ],
        troubles: [
          '"Kho chưa gửi danh sách đồ của cơ sở này" → chọn "Mọi cơ sở" để xem đồ ở cơ sở khác, hoặc hỏi quản lý kho.',
          "Không có chiếc nào khớp → bỏ bớt ô lọc, bỏ chọn concept, hoặc bật \"Xem cả đồ không vừa\".",
          "Ghim báo chiếc đã rời kho → tải lại trang, chọn chiếc khác.",
          'Không thấy nút "Ghim vào đơn" → bạn đang mở trang từ menu, hãy mở từ đơn của khách.',
          "Ảnh hiện \"Chưa có ảnh\" → kho chưa chụp chiếc đó, hỏi quản lý kho.",
        ],
      },
      {
        for: ["photo", "makeup", "assistant"],
        title: "Việc của ekip",
        steps: [
          'Trước buổi chụp, mở đơn, xem khối "Đồ khách đã chọn" để biết khách đã chọn chiếc nào.',
          'Cần tìm thêm đồ hợp khách: bấm "Tra đồ cho khách này", xem số đo đã lưu và các chiếc vừa.',
        ],
        troubles: ['Chiếc đã chọn hiện "đã rời kho" → báo Sale hoặc CSKH của đơn để chọn lại cùng khách.'],
      },
      {
        for: ["lead", "exec"],
        title: "Việc của quản lý",
        steps: [
          "Dùng trang này như Sale để tư vấn hộ khi cần; chọn \"Mọi cơ sở\" để xem đồ toàn hệ thống.",
          'Nhắc đội lưu số đo khách và ghim đồ khách đã chốt, để ekip ngày chụp thấy ở khối "Đồ khách đã chọn".',
          'Thấy nhiều chiếc "Chưa có ảnh" hoặc "Số đo theo bảng size chung" → nhắc quản lý kho chụp ảnh và đo đồ.',
        ],
        troubles: ["Danh sách trống cả hệ thống → kho chưa gửi danh sách đồ, báo bộ phận IT."],
      },
    ],
  },
};
